export default class DictionaryJS {
    constructor() {
        this.keys = [];
        this.values = [];

        DictionaryJS.prototype.Add = function (key, value) {
            var index = this.keys.indexOf(key);
            if (index === -1) {
                this.keys.push(key);
                this.values.push(value);
                return true;
            } else return false;
        };
        DictionaryJS.prototype.Remove = function (key) {
            var index = this.keys.indexOf(key);
            if (index > -1) {
                this.keys.splice(index, 1);
                this.values.splice(index, 1);
                return true;
            } else return false;
        };

        DictionaryJS.prototype.GetKeys = function () {
            return this.keys;
        };

        DictionaryJS.prototype.GetValues = function () {
            return this.values;
        };
        DictionaryJS.prototype.Get = function (key) {
            var index = this.keys.indexOf(key);
            if (index > -1)
                return this.values[index];
            else
                return [];
        };
        DictionaryJS.prototype.Count = function () {
            return this.values.length;
        };
        DictionaryJS.prototype.Clear = function () {
            this.keys = [];
            this.values = [];
        };
        DictionaryJS.prototype.ContainsKey = function (key) {
            var index = this.keys.indexOf(key);
            if (index > -1)
                return true;
            else return false;
        };
        DictionaryJS.prototype.ContainsValue = function (value) {
            var index = this.values.indexOf(value);
            if (index > -1)
                return true;
            else return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/topComponents/DictionaryJS.js